<page-title [title]="titles[0]" *ngIf="qualifications?.length"></page-title>
<mat-card *ngIf="qualifications?.length">
  <p *ngFor="let qualification of qualifications" class="desc">{{qualification?.name}}</p>

</mat-card>      
<page-title [title]="titles[1]" *ngIf="certificates?.length"></page-title> 
<mat-card *ngIf="certificates?.length">
  <p *ngFor="let certificate of certificates" class="desc">{{certificate?.name}}</p>  
</mat-card>                
<page-title [title]="titles[2]" *ngIf="languages?.length"></page-title>
<mat-card *ngIf="languages?.length">
  <p *ngFor="let language of languages" class="desc">{{language?.language}}</p>  
</mat-card>                 